const isRealObj = (v) => {
  return typeof v === 'object' && !Array.isArray(v) && v !== null;
};

export default isRealObj;
